import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { PostalAddressForm } from '#src/components/settings/PostalAddressForm/index.tsx';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  DeletePostalAddressMutation,
  DeletePostalAddressMutationVariables,
} from './__generated__/useDeleteUserPostalAddress.graphql.ts';

const QUERY = gql`
  mutation DeletePostalAddressMutation($input: deletePostalAddressInput!) {
    deletePostalAddress(input: $input) {
      currentUser {
        slug
        id
        userSettings {
          id
          ...PostalAddressForm_userSettings
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${/* oxlint-disable-next-line sorare/no-detached-fragments */ ''}
  ${PostalAddressForm.fragments.userSettings}
` as TypedDocumentNode<
  DeletePostalAddressMutation,
  DeletePostalAddressMutationVariables
>;

export const useDeleteUserPostalAddress = () => {
  const [mutate, { loading }] = useMutation(QUERY, {
    showErrorsWithSnackNotification: true,
  });

  return {
    deleteUserPostalAddress: async () => mutate({ variables: { input: {} } }),
    loading,
  };
};
